module.exports = __webpack_public_path__ + "img/FTRC-bubbles.f6dd9289.png";